export default __webpack_public_path__ + "static/media/flag-faroe-islands.196e3de8.svg";